import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { mediaPickerActions } from '../store';
import CircleProgressButton from '../../../../buttons/CircleProgressButton';
import { createActions } from '../../store';
import { createLocalMediaSourceUrls, createMediaSource, createMediaSourceDataForVideo } from '../../helpers';
import { MEDIA_RESOURCE_TYPE, MEDIA_SOURCE_TYPE } from '../../CreatePageConstants';
import AppConstants from '../../../../../App/AppConstants';

const styles = theme => ({
    cancelButton: {
        marginRight: theme.spacing(2)
    }
});

const StockVideoPreviewActions = (props) => {
    const { 
        classes, backgroundStockVideoPreviewProcessing, backgroundStockVideoPreviewData, hideStockVideoPreview, 
        setMediaPickersProperty, setPageProperty, updateBackgroundSettings, openPremiumVideosDialog,
        subscriptionType, savingInProgress, showCriticalOperationProgressWarning
    } = props;

    const onCancelClick = () => {
        hideStockVideoPreview();
    };

    const onSaveClick = () => {
        if (subscriptionType === AppConstants.FREE_SUBSCRIPTION_TYPE && backgroundStockVideoPreviewData.isPremium) { 
            setMediaPickersProperty('backgroundMediaPickerOpen', false);
            hideStockVideoPreview();
            
            openPremiumVideosDialog(backgroundStockVideoPreviewData.urls.exampleUrl, () => {
                setMediaPickersProperty('backgroundMediaPickerOpen', true);
            }, 'stock videos');
        } else {
            // Don't apply the catalog video if the save operation is in progress.
            if (savingInProgress) {
                showCriticalOperationProgressWarning();
                return;
            }
            
            const mediaData = createMediaSourceDataForVideo(
                backgroundStockVideoPreviewData.urls.p1080Url, 
                backgroundStockVideoPreviewData.urls.p720Url, 
                backgroundStockVideoPreviewData.urls.p540Url, 
                backgroundStockVideoPreviewData.urls.p360Url
            );

            const mediaSource = createMediaSource(mediaData, MEDIA_SOURCE_TYPE.STOCK_VIDEO, backgroundStockVideoPreviewData.stockVideoId, MEDIA_RESOURCE_TYPE.VIDEO);
    
            setPageProperty('backgroundVideosLoading', true);
            createLocalMediaSourceUrls(mediaSource, (localMediaSource) => {
                updateBackgroundSettings({ mediaSource: localMediaSource });
                setPageProperty('backgroundVideosLoading', false);
            });
    
            setMediaPickersProperty('backgroundMediaPickerOpen', false);
            hideStockVideoPreview();
        }
    };

    return (
        <>
            <Button
                className={classes.cancelButton} 
                onClick={onCancelClick}
            >
                Cancel
            </Button>
            <CircleProgressButton
                onClick={onSaveClick}
                loading={backgroundStockVideoPreviewProcessing}
                variant='outlined'
                color='primary'
            >
                Save
            </CircleProgressButton>
        </>
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundStockVideoPreviewProcessing, 
        backgroundStockVideoPreviewData 
    } = state.mediaPicker;

    const { subscriptionType } = state.app.accountDetails;
    const { savingInProgress } = state.create.videoSavingState;

    return { 
        backgroundStockVideoPreviewProcessing,
        backgroundStockVideoPreviewData,
        subscriptionType,
        savingInProgress
    };
}

const mapDispatchToProps = (dispatch) => {
    const setMediaPickersProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const setPageProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    const hideStockVideoPreview = () => dispatch(mediaPickerActions.hideStockVideoPreview());
    const openPremiumVideosDialog = (videoUrl, onGoBack, location) => dispatch(mediaPickerActions.openPremiumVideosDialog(videoUrl, onGoBack, location));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return { 
        setMediaPickersProperty,
        setPageProperty,
        updateBackgroundSettings,
        hideStockVideoPreview,
        openPremiumVideosDialog,
        showCriticalOperationProgressWarning
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(StockVideoPreviewActions, styles));